import React from 'react';
import { Bell } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SIDEBAR_ACTION_HOVER_GROUP } from '../utils/sidebar-action-hover';

interface RingingBellIconProps {
  className?: string;
  size?: number;
  hoverGroup?: string;
}

export const RingingBellIcon: React.FC<RingingBellIconProps> = ({
  className,
  size,
  hoverGroup = SIDEBAR_ACTION_HOVER_GROUP,
}) => {
  return (
    <Bell
      size={size}
      className={cn(
        'h-4 w-4 shrink-0 origin-top transition-transform duration-300',
        `group-hover/${hoverGroup}:-rotate-12`,
        className,
      )}
    />
  );
};
